export const FAULT_REASON_BAR_SEGMENTS = 7;

/**
 * Quantos dos `FAULT_REASON_BAR_SEGMENTS` blocos ficam acesos para uma dada
 * proporção — arredonda pro inteiro mais próximo, mas garante ao menos 1
 * bloco aceso sempre que `percentage > 0` (senão um motivo com proporção
 * pequena ficaria com a barra inteiramente apagada).
 */
export function computeLitSegments(percentage: number): number {
  const safePercentage = Number.isFinite(percentage) ? Math.min(100, Math.max(0, percentage)) : 0;
  if (safePercentage <= 0) return 0;
  return Math.max(1, Math.round((safePercentage / 100) * FAULT_REASON_BAR_SEGMENTS));
}

/**
 * Opacidade de cada bloco (Figma node 233:2693): os acesos degradam
 * 100% → 40% → 10% e os apagados somem, mas seguem ocupando espaço para
 * que todas as barras da lista fiquem alinhadas.
 */
export function segmentOpacity(index: number, litCount: number): number {
  if (index >= litCount) return 0;
  if (index === 0) return 1;
  if (index === 1) return 0.4;
  return 0.1;
}
